import * as React from "react";
import type { SVGProps } from "react";
const SvgEmptyStateIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="currentColor"
      d="M24.348 23.104c-.357 0-.688-.203-.888-.542L13.716 6.618 3.763 22.58c-.2.331-.528.528-.877.528H1.369l9.808-16.079c.292-.466.674-.899 1.13-1.281.385-.324.888-.48 1.525-.48.604 0 1.103.152 1.482.45.437.346.812.783 1.117 1.3L26 23.104h-1.655z"
    />
    <path
      fill="currentColor"
      d="M13.36 17.177h-1.592v1.591h1.591zM15.595 17.177h-1.59v1.591h1.59zM15.595 19.336h-1.59v1.591h1.59zM13.36 19.336h-1.592v1.591h1.591z"
    />
  </svg>
);
export default SvgEmptyStateIcon;
